export default "__VITE_ASSET__C8VBdg8w__"